import { Component, Input, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { AtualizacoesAuditService } from '../../../services/atualizacoes-audit.service';

@Component({
  selector: 'app-historico-atualizacoes-list',
  templateUrl: './historico-atualizacoes-list.component.html',
  styleUrls: ['./historico-atualizacoes-list.component.scss'],
})
export class HistoricoAtualizacoesListComponent
  extends BaseListComponent<AtualizacoesAudit>
  implements OnInit
{
  @Input() audit: AtualizacoesAudit; // contém o campo da fk da tabela a ser auditada
  @Input() listAudit: AtualizacoesAudit[] = [];
  @Input() loadList: boolean = true;
  @Input() key: string;
  atualizacoes: AtualizacoesAudit[] = [];
  visivel: boolean = false;
  show: boolean = false;

  constructor(private myService: AtualizacoesAuditService) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();

    this.addSub(
      EventSharedService.get('auditRefresh').subscribe((res) => {
        if (res) {
          this.listAudit = res;
        }
        this.loading();
        this.initLoadDataTable();
      })
    );
  }

  initLoadDataTable() {
    if (typeof this.audit != 'undefined' && this.loadList) {
      this.addSub(
        this.myService.getAtualizacoes(this.audit).subscribe({
          next: (res) => {
            this.initList(res);
            this.loaded();
          },
          error: (error) => {
            this.loaded();
          },
        })
      );
    } else if (!this.loadList) {
      this.initList(this.listAudit);
      this.loaded();
    } else {
      this.loaded();
    }
  }

  initList(obj: AtualizacoesAudit[]) {
    if (this.key) {
      obj = obj.filter((item) => item[this.key]);
    }

    obj.forEach((audit) => {
      audit.summary =
        '<li>' + audit.summary.replace(/[\r\n]+/g, '</li><li>') + '</li>';
      audit.summary = audit.summary.replace('\n', '</li><li>');
    });
    this.show = true;
    this.atualizacoes = obj;
  }
}
